import httpClient from "./httpClient";
const support = {
  claim (data, type) {
    const url = type ? `/api/adv/claim/${type}` : '/api/adv/email';
    return httpClient.post(url, data);
  },
  get (type) {
    return httpClient
      .get(`/api/claim/${type.toLowerCase()}`)
      .then(
        response => response.success ? response.claim : undefined
      )
  },
  getSupportByKeyword(keyword) {
    return httpClient
      .get(`/api/v2/social-support/keyword/${keyword}`)
      .then(
        response => response.success ? response.psySocialSupport : undefined
      )
  },
}

export default support
